import { RecordingStatus, StepClass } from '../common';
import { getMediaStatus } from '../media';
// isWelcomeStep and isExitStep are imported from selectors.ts but they probably
// should have been defined here as they are step-specific.
// eslint-disable-next-line import/no-cycle
import { isExitStep, isWelcomeStep } from './selectors';
import { PrototypeStepType, YesOrNoStepType, } from './types';
export function setDescription(mutable, value) {
    mutable.description = value;
}
export function setTitle(mutable, value) {
    mutable.title = value;
}
export function setImage(mutable, value) {
    const decorativeImage = { url: value };
    mutable.decorativeImage = decorativeImage;
}
export function removeImage(mutable) {
    delete mutable.decorativeImage;
}
export function removeInstruction(mutable) {
    delete mutable.instruction;
}
export function getInstruction(step) {
    var _a;
    return (_a = step.instruction) !== null && _a !== void 0 ? _a : null;
}
export function getInstructionStatus(step) {
    return getMediaStatus({ mutable: step });
}
export function getReadyInstruction(step) {
    var _a;
    if (((_a = step === null || step === void 0 ? void 0 : step.instruction) === null || _a === void 0 ? void 0 : _a.status) === RecordingStatus.Ready) {
        return {
            url: step.instruction.url,
            mimeType: step.instruction.mimeType,
        };
    }
}
export function isOfType(item, type) {
    return item.className === StepClass[type];
}
export function isOneOfType(item, types) {
    return types.some((type) => isOfType(item, type));
}
export function isRequirable(step) {
    return (!isOfType(step, StepClass.Instruction) &&
        !(isStepWithSubType(step) && step.type === YesOrNoStepType.Legal));
}
export function isStepWithSubType(step) {
    return step.type !== undefined;
}
export function isChoiceStep(step) {
    return isOneOfType(step, [
        StepClass.MultipleChoice,
        StepClass.PreferenceTest,
        StepClass.TaglineCopyTest,
    ]);
}
export function getRecordingPermissions(step) {
    var _a;
    return ((_a = step.recordingPermissions) !== null && _a !== void 0 ? _a : {
        microphone: false,
        webcam: false,
        screen: false,
    });
}
export function setMicrophoneRecordingPermission(mutable, microphone) {
    mutable.recordingPermissions = Object.assign(Object.assign({}, getRecordingPermissions(mutable)), { microphone });
}
export function setWebcamRecordingPermission(mutable, webcam) {
    mutable.recordingPermissions = Object.assign(Object.assign({}, getRecordingPermissions(mutable)), { webcam });
}
export function setScreenRecordingPermission(mutable, screen) {
    mutable.recordingPermissions = Object.assign(Object.assign({}, getRecordingPermissions(mutable)), { screen });
}
export function canEnableParticipantsRecording(step) {
    return ((step.className === StepClass.PrototypeTask &&
        // We'll enable this when we add recording to all steps
        (step === null || step === void 0 ? void 0 : step.type) !== PrototypeStepType.FirstClick) ||
        step.className === StepClass.WebsiteTask);
}
export function getIsRequired(step) {
    return step.isRequired;
}
export function setIsRequired(mutable, isRequired) {
    mutable.isRequired = isRequired;
}
export function setAlwaysConditionalRule(mutable, selectedStepUUID) {
    if (mutable.conditions) {
        mutable.conditions.ALWAYS = selectedStepUUID;
    }
    else {
        mutable.conditions = {
            ALWAYS: selectedStepUUID,
        };
    }
}
export function deleteAlwaysConditionalRule(mutable) {
    if (mutable.conditions) {
        mutable.conditions.ALWAYS = null;
    }
    else {
        mutable.conditions = {
            ALWAYS: null,
        };
    }
}
export function isConditionable(step, userTest) {
    return !(isWelcomeStep(userTest, step.uuid) ||
        isExitStep(userTest, step.uuid) ||
        isOfType(step, StepClass.MediaSettings) ||
        ('type' in step && step.type === YesOrNoStepType.Legal));
}
